export const MAX_PARTNER_LIST_CELL_TEXT_LENGTH = 25;
